export const SET_FORM_SELECTORS = '@@REPORT_STATUS/SET_FORM_SELECTORS';
export const SET_TABLE_DATA = '@@REPORT_STATUS/SET_TABLE_DATA';
export const SET_IS_LOADING = '@@REPORT_STATUS/SET_IS_LOADING';
export const SET_REPORT_KINDS = '@@REPORT_STATUS/SET_REPORT_KINDS';
export const RESET_STATE = '@@REPORT_STATUS/RESET_STATE';
